// Copyright © 2026 Gian Marco Cappelli — SAPIENS (finsapiens.it). Tutti i diritti riservati. Sviluppato su commissione esclusiva. Vietata la riproduzione senza autorizzazione scritta.
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { EducBox, ResultCard, InputRow, EDUC, fmt } from './shared';

const EmergencyCalc = ({ onStepComplete }) => {
  const [spese, setSpese] = useState('1500');
  const [mesi, setMesi] = useState('3');
  const [risparmioMensile, setRisparmioMensile] = useState('300');
  const [giaSalvato, setGiaSalvato] = useState('0');

  const obiettivo = (parseFloat(spese) || 0) * (parseInt(mesi) || 0);
  const giaSalvatoN = parseFloat(giaSalvato) || 0;
  const mancante = Math.max(0, obiettivo - giaSalvatoN);
  const mesiFine = risparmioMensile > 0 ? Math.ceil(mancante / (parseFloat(risparmioMensile) || 1)) : Infinity;

  useEffect(() => {
    if (obiettivo > 0 && onStepComplete) onStepComplete();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [obiettivo > 0]);

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <EducBox text={EDUC.emergency} />
      <div className="grid sm:grid-cols-2 gap-4 mb-6">
        <InputRow label="Spese mensili essenziali (€)" value={spese} onChange={setSpese} prefix="€" />
        <InputRow label="Mesi di copertura desiderati" value={mesi} onChange={setMesi} suffix="mesi" />
        <InputRow label="Risparmio mensile disponibile (€)" value={risparmioMensile} onChange={setRisparmioMensile} prefix="€" />
        <InputRow label="Già risparmiato (€)" value={giaSalvato} onChange={setGiaSalvato} prefix="€" />
      </div>
      <div className="grid grid-cols-3 gap-4">
        <ResultCard label="Fondo obiettivo" value={`€${fmt(obiettivo)}`} green />
        <ResultCard label="Ancora mancante" value={`€${fmt(mancante)}`} />
        <ResultCard label="Tempo stimato" value={isFinite(mesiFine) ? `${mesiFine} mesi` : '—'} gold />
      </div>
</motion.div>
  );
};

export default EmergencyCalc;
